<template>
    <div>
        <div class="loader" v-if="this.isLoading || this.isLoadingCheck"></div>
        <div class="loadertext" v-if="this.isLoading  || this.isLoadingCheck"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading  || this.isLoadingCheck}">
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->


            <div class="page-wrapper">

                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <h6 class="card-title mb-0 float-start" style="padding-left:25px"> {{ $t('create') + " "
                                        + $t('pib') }} - {{ this.forms.status }}</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="mb-3">
                                            <h5>{{ reFormatAju() }}</h5>
                                            <form class="forms-sample" @submit.prevent="submitData" method="POST">

                                                <button class="btn btn-primary float-end btn-sm me-2" type="submit" :disabled="!validateTab?.CheckFlag">
                                                    <i class="link-icon mdi mdi-content-save"></i>
                                                    {{ $t("submitFormTxt") }}
                                                </button>

                                            </form>

                                            <button class="btn btn-warning float-end btn-sm me-2" @click.prevent="showPdf" :disabled="!validateTab?.CheckFlag">
                                                    <i class="link-icon mdi mdi-printer-outline"></i>
                                                    Cetak
                                                </button>
                                            <button class="btn btn-success float-end btn-sm me-2" v-show="!(forms.is_submit == 0 || forms.is_submit == null)" @click.prevent="updateSubmit" >
                                                <i class="link-icon mdi mdi-check"></i>
                                                Force Submit
                                            </button>
                                            <button class="btn btn-danger float-end btn-sm me-2" v-show="forms.is_submit == 0 || forms.is_submit == null" @click.prevent="updateSubmit">
                                                <i class="link-icon mdi mdi-close"></i>
                                                Force Submit
                                            </button>
                                        </div>
                                    </div>
                                    <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">

                                        <li class="nav-item">
                                            <a class="nav-link active" :class="{'text-danger':!validateTab?.Header?.status}" id="home-line-tab" data-bs-toggle="tab" href="#home"
                                                role="tab" aria-controls="home" aria-selected="true"> {{ $t('header') }}
                                            </a>
                                        </li>

                                        <li class="nav-item">
                                            <a class="nav-link" id="entitas-line-tab" data-bs-toggle="tab" href="#entitas" :class="{'text-danger':!validateTab?.Entitas?.status}"
                                                role="tab" aria-controls="disabled" aria-selected="false"> {{ $t('entitas')
                                                }} </a>
                                        </li>

                                        <li class="nav-item">
                                            <a class="nav-link" id="dokumen-line-tab" data-bs-toggle="tab" href="#dokumen" :class="{'text-danger':!validateTab?.Document?.status}"
                                                role="tab" aria-controls="disabled" aria-selected="false"> {{ $t('dokumen')
                                                }} </a>
                                        </li>

                                        <li class="nav-item">
                                            <a class="nav-link" id="pengangkut-line-tab" data-bs-toggle="tab" :class="{'text-danger':!validateTab?.Pengangkut?.status}"
                                                href="#pengangkut" role="tab" aria-controls="disabled"
                                                aria-selected="false"> {{ $t('pengangkut') }} </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="kemasan-line-tab" data-bs-toggle="tab" href="#kemasan" :class="{'text-danger':!validateTab?.Kemasan?.status}"
                                                role="tab" aria-controls="disabled" aria-selected="false"> {{ $t('kemasan_petiKemas')
                                                }} </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="transaksi-line-tab" data-bs-toggle="tab" href="#transaksi" :class="{'text-danger':!validateTab?.Transaksi?.status}"
                                                role="tab" aria-controls="disabled" aria-selected="false"> {{ $t('transaksi')
                                                }} </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="detail_barang-line-tab" data-bs-toggle="tab" :class="{'text-danger':!validateTab?.Barang?.status}"
                                                href="#detail_barang" role="tab" aria-controls="detail_barang"
                                                aria-selected="false">{{ $t('barang_txt') }}</a>
                                        </li>

                                        

                                        <li class="nav-item">
                                            <a class="nav-link" id="pungutan-line-tab" data-bs-toggle="tab"
                                                href="#pungutan" role="tab" aria-controls="disabled" aria-selected="false">
                                                Pungutan </a>
                                        </li>

                                        <li class="nav-item">
                                            <a class="nav-link" id="pernyataan-line-tab" data-bs-toggle="tab" :class="{'text-danger':!validateTab?.Pernyataan?.status}"
                                                href="#pernyataan" role="tab" aria-controls="disabled" aria-selected="false">
                                                {{ $t('pernyataan') }} </a>
                                        </li>



                                    </ul>

                                    <div class="tab-content mt-3" id="lineTabContent">
                                        <div class="tab-pane fade show active" id="home" role="tabpanel"
                                            aria-labelledby="home-line-tab">
                                            <ceisa-header :propsData="forms" @formUpdate="updateForms" @updateData="updateData"></ceisa-header>
                                        </div>
                                        <div class="tab-pane fade show" id="entitas" role="tabpanel"
                                            aria-labelledby="entitas-line-tab">
                                            <ceisa-entitas :propsData="forms" @formUpdate="updateForms" @updateData="updateData"></ceisa-entitas>
                                        </div>
                                        <div class="tab-pane fade show" id="dokumen" role="tabpanel"
                                            aria-labelledby="dokumen-line-tab">
                                            <ceisa-dokumen :propsData="forms" :validate="validateTab?.Document?.messages" @formUpdate="updateForms" @updateData="updateData"></ceisa-dokumen>
                                        </div>
                                        <div class="tab-pane fade show" id="pengangkut" role="tabpanel"
                                            aria-labelledby="pengangkut-line-tab">
                                            <ceisaPengangkut :propsData="forms" @formUpdate="updateForms" @updateData="updateData"></ceisaPengangkut>
                                        </div>
                                        <div class="tab-pane fade show" id="kemasan" role="tabpanel"
                                            aria-labelledby="kemasan-line-tab">
                                            <ceisaKemasan :propsData="forms"  :validate="validateTab?.Kemasan?.messages" @formUpdate="updateForms" @updateData="updateData"></ceisaKemasan>
                                        </div>
                                        <div class="tab-pane fade show" id="transaksi" role="tabpanel"
                                            aria-labelledby="transaksi-line-tab">
                                            <ceisaTransaksi :propsData="forms" @formUpdate="updateForms" @updateData="updateData" ref="ceisaTransaksi"></ceisaTransaksi>
                                        </div>
                                        <div class="tab-pane fade show" id="detail_barang" role="tabpanel"
                                            aria-labelledby="detail_barang-line-tab">
                                            <ceisaBarang :propsData="forms" :validate="validateTab?.Barang?.messages" @formUpdate="updateForms" @updateData="updateData" @forceSubmit="forceSubmitTransaksi"></ceisaBarang>
                                        </div>
                                        <div class="tab-pane fade show" id="pernyataan" role="tabpanel"
                                            aria-labelledby="pernyataan-line-tab">
                                            <ceisaPernyataan :propsData="forms" @formUpdate="updateForms" @updateData="updateData"></ceisaPernyataan>
                                        </div>
                                        <div class="tab-pane fade show" id="pungutan" role="tabpanel"
                                            aria-labelledby="pungutan-line-tab">
                                            <ceisaPungutan :propsData="forms" @formUpdate="updateForms" @updateData="updateData"></ceisaPungutan>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <modalDokumenPdf :documentId="idDocument" ></modalDokumenPdf>
                </div>

                

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>

import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import ceisaHeader from "@/components/exim/ceisa/barang_impor/CeisaBarangImporHeader.vue";
import ceisaEntitas from "@/components/exim/ceisa/barang_impor/CeisaBarangImporEntitas.vue";
import ceisaDokumen from "@/components/exim/ceisa/barang_impor/CeisaBarangImporDokumen.vue";
import ceisaPengangkut from "@/components/exim/ceisa/barang_impor/CeisaBarangImporPengangkut.vue";
import ceisaKemasan from "@/components/exim/ceisa/barang_impor/CeisaBarangImporKemasan.vue";
import ceisaTransaksi from "@/components/exim/ceisa/barang_impor/CeisaBarangImporTransaksi.vue";
import ceisaBarang from "@/components/exim/ceisa/barang_impor/CeisaBarangImporBarangGrouped.vue";
import ceisaPernyataan from "@/components/exim/ceisa/barang_impor/CeisaBarangImporPernyataan.vue";
import ceisaPungutan from "@/components/exim/ceisa/barang_impor/CeisaBarangImporPungutan.vue";
import modalDokumenPdf from "@/components/exim/ceisa/barang_impor/modal/modalDokumenPdf.vue";


// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/locale/id';
export default {
    name: "CeisaBarangImporCreate",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        "ceisa-header": ceisaHeader,
        "ceisa-entitas": ceisaEntitas,
        "ceisa-dokumen": ceisaDokumen,
        ceisaPengangkut,
        ceisaKemasan,
        ceisaTransaksi,
        ceisaBarang,
        ceisaPernyataan,
        ceisaPungutan,
        modalDokumenPdf,
        // DatePicker

    },
    data() {
        return {
            permision_role: [],
            isLoading: false,
            isLoadingCheck:false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            idDocument:null,
            forms: {
                document_import_id: "",
                type: "document_import",
                asalData: "S",
                asuransi: 0,
                bruto: 0,
                cif: 0,
                disclaimer: "",
                kodeJenisProsedur: "",
                namaJenisProsedur: "",
                kodeJenisImpor: "",
                namaJenisImpor: "",
                kodeJenisEkspor: "",
                flagVd: "",
                fob: 0,
                freight: 0,
                hargaPenyerahan: 0,
                idPengguna: "",
                jabatanTtd: "",
                jumlahKontainer: 0,
                jumlahTandaPengaman: 0,
                kodeAsuransi: "",
                kodeCaraBayar: "",
                kodeDokumen: "",
                kodeIncoterm: "",
                kodeJenisNilai: "",
                kodeKantor: "",
                kodePelMuat: "",
                namaPelTujuan: "",
                kodePelTujuan: "",
                kodeTps: "",
                kodeTutupPu: "",
                namaTutupPu: "",
                kodeValuta: "",
                kotaTtd: "",
                namaTtd: "",
                ndpbm: 0,
                netto: 0,
                nilaiBarang: 0,
                nilaiIncoterm: 0,
                nilaiMaklon: 0,
                nomorAju: "",
                nomorBc11: "",
                posBc11: "",
                seri: 0,
                subposBc11: "",
                tanggalAju: "",
                tanggalBc11: "",
                tanggalTiba: "",
                tanggalTtd: "",
                totalDanaSawit: "",
                volume: "",
                vd: "",
                biayaTambahan: "",
                biayaPengurang: "",
                created_by: "",
                updated_by: "",
                created_at: "",
                updated_at: "",
                status: "DRAFT",
                nama_pengirim: "",
                alamat_pengirim: "",
                country_pengirim: "",
                country_code_pengirim: "",
                nama_penjual: "",
                alamat_penjual: "",
                country_penjual: "",
                country_code_penjual: "",
                importir_identitas: "",
                importir_nama: "",
                importir_alamat: "",
                importir_status: "",
                importir_nib: "",
                pemilik_barang_nama: "",
                pemilik_barang_identitas: "",
                pemilik_barang_alamat: "",
                ppjk_id: "",
                ppjk_no_npwp: "",
                ppjk_nama: "",
                ppjk_alamat: "",
                ppjk_np_ppjk: "",
                cara_pengangkutan_nama: "",
                cara_pengangkutan_kode: "",
                sarana_pengangkutan_nama: "",
                sarana_pengangkutan_no_voy: "",
                sarana_pengangkutan_bendera: "",
                sarana_pengangkutan_bendera_kode: "",
                perkiraaan_tanggal_tiba: "",
                pelabuhan_muat_nama: "",
                pelabuhan_muat_kode: '',
                pelabuhan_transit_nama: "",
                pelabuhan_transit_kode: '',
                pelabuhan_tujuan_nama: "",
                pelabuhan_tujuan_kode: '',
                invoice_no: "",
                invoice_date: "",
                transaksi_code: "",
                transaksi_no: "",
                transaksi_date: "",
                house_bl_awb_no: "",
                house_bl_awb_date: "",
                master_bl_awb_no: "",
                master_bl_awb_date: "",
            },

            validateTab:[],
        }
    },
    methods: {
        updateSubmit(){
            var submit = this.forms.is_submit;
            var send = [];
            var text = "";
            if(submit == null || submit == 0){
                send = {
                    "is_submit":1
                }
                text = "Dokumen ini akan langsung terkirim tanpa melalui draft terlebih dahulu";
            }else{
                send = {
                    "is_submit":0
                }
                text = "Dokumen ini tidak akan langsung terkirim ke Bea Cukai";
            }
            this.$swal({
                title: this.$t("areYouSure"),
                text: text,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    const baseURI = this.$settings.endPointCeisa + "v1/document/update-status-submit/"+this.forms.document_id;
                    
                    this.$http.post(baseURI, send, { timeout: 10000 }).then((response) => {
                        this.loading();
                        if (response.data.status === 200) {
                            this.errors = [];
                            this.loadData();
                            this.success('Berhasil');
                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                    }).catch(error => {
                        this.loading();
                        if (error.code == "ECONNABORTED") {
                            this.error("Please Check Your Internet Connection");
                        }

                        if (error.response) {
                            if (error.response.status === 422) {
                                var arr = error.response.data.errors;
                                if(arr?.messages[0]?.Exception){
                                    this.error(arr.messages[0].Exception);
                                }else{
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                }
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }
                    });
                } else {
                    this.isLoading = false;
                }
            });
        
        },
        reFormatAju(){
            var kodeKantor = this.forms?.kodeKantor ? this.forms?.kodeKantor : "0000";
            var kodeDokumen = this.forms?.kodeDokumen ? this.forms?.kodeDokumen : "00";
            var npwp = this.forms?.ppjk_no_npwp ? this.forms?.ppjk_no_npwp.substr(-6) : "000000";
            var tanggalAju =  "000000";

            if(this.forms?.tanggalAju !== "0000-00-00"){
                tanggalAju =this.$moment(this.forms?.tanggalAju).format("YYYYMMDD");
            }

            var aju = this.forms?.nomorAju ? this.forms?.nomorAju.substr(-6) : "000000";
            return kodeKantor+kodeDokumen+"-"+npwp+"-"+tanggalAju+"-"+aju;

        },
        forceSubmitTransaksi(){
            this.$refs.ceisaTransaksi.submitData();
        },
        submitData(){

            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataSend"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;

                    const baseURI = this.$settings.endPointCeisa + "v1/document/send-data/"+this.forms.document_id;
                    
                    this.$http.post(baseURI, { timeout: 10000 }).then((response) => {
                        if (response.data.status === 200) {
                            this.isLoading = false;
                            this.errors = [];
                            window.location.href = "/exim/ceisa/dokumen-pabean?status=200&msg=Successfully";
                        } else {
                            this.isLoading = false;
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                    }).catch(error => {
                        this.isLoading = false;
                        if (error.code == "ECONNABORTED") {
                            this.error("Please Check Your Internet Connection");
                        }

                        if (error.response) {
                            if (error.response.status === 422) {
                                var text = this.prettyJson(error.response.data.errors.messages);
                                this.$swal({
                                    icon: "error",
                                    title:"Oops...",
                                    text:text,
                                });
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }
                    });
                } else {
                    this.isLoading = false;
                }
            });
        },
        prettyJson(value) {

            if (value) {

                var str = '';

                try {
                    str = JSON.stringify(JSON.parse(value), null, 2);
                } catch (e) {
                    str = value;
                }

                return str;
            } else {
                return value;
            }

        },
        showPdf(){
            this.idDocument = this.forms.document_id;
            this.$modal.show('DocumentPdf');

        },
        async updateData(ev=null) {
            await this.loadData();

            if(ev == 'submitTransaksi'){
                this.forceSubmitTransaksi();
            }
        },
        updateForms(ev) {
            this.forms = ev;
        },
        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaBarangImporController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_create) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

            this.loadData();
            // this.asyncPelabuhanTujuan();
            // this.asynckodeKantor();
            // this.asynckodeJenisProsedur();
            // this.asynckodeCaraBayar();
            // this.asyncTipeIdentitas();
            // this.asynckodeJenisImpor();
            // this.asynckodeJenisApi();
            // this.asyncstatusImportir();
            // this.asynckodeNegara();
            // this.asyncKodeDokumen();
            // this.asyncFasilitasDokumen();
            // this.asynckodeTutupPu();

        },

        checkData() {

            this.isLoadingCheck = true;

            var params = this.$onBehind(this.$route.params.id);
            var id = params[0];

            const baseURI = this.$settings.endPointCeisa + "v1/document/check-data/" + id;

            return this.$http.get(baseURI, { timeout: 100000 }).then((response) => {
                this.validateTab = response.data.datas;
                this.isLoadingCheck = false;

            }).catch(error => {

                this.isLoadingCheck = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });

        },
        loadData() {

            this.isLoading = true;

            var params = this.$onBehind(this.$route.params.id);
            var id = params[0];

            const baseURI = this.$settings.endPointCeisa + "v1/document/detail/" + id;

            return this.$http.get(baseURI, { timeout: 100000 }).then((response) => {
                this.checkData();

                this.isLoading = false;
                this.forms = response.data.datas;
                this.pelabuhan_tujuan = { code: response.data.datas.kodePelTujuan, name: response.data.datas.namaPelTujuan, label: response.data.datas.kodePelTujuan + " - " + response.data.datas.namaPelTujuan }
                this.kodeKantor = { code: response.data.datas.kodeKantor, name: response.data.datas.namaKantor, label: response.data.datas.kodeKantor + " - " + response.data.datas.namaKantor }
                this.kodeJenisProsedur = { code: response.data.datas.kodeJenisProsedur, name: response.data.datas.namaJenisProsedur, label: response.data.datas.kodeJenisProsedur + " - " + response.data.datas.namaJenisProsedur }
                this.kodeJenisImpor = { code: response.data.datas.kodeJenisImpor, name: response.data.datas.namaJenisImpor, label: response.data.datas.kodeJenisImpor + " - " + response.data.datas.namaJenisImpor }
                this.kodeCaraBayar = { code: response.data.datas.kodeCaraBayar, name: response.data.datas.namaCaraBayar, label: response.data.datas.kodeCaraBayar + " - " + response.data.datas.namaCaraBayar }
                this.kodeTutupPu = { code: response.data.datas.kodeTutupPu, name: response.data.datas.namaTutupPu, label: response.data.datas.kodeTutupPu + " - " + response.data.datas.namaTutupPu }
                var entitas = response.data.datas.entitas;
                this.rowsDokumen = response.data.datas.dokumen;

                if (entitas.length > 0) {


                    for (var x = 0; x < entitas.length; x++) {

                        var ob = entitas[x];
                        if (ob.kodeEntitas == "1") {
                            this.entitasImportir = ob;
                            this.importirkodeStatus.code = ob.kodeStatus
                            this.importirTipeIdentitas = { code: ob.kodeJenisIdentitas, name: ob.namaJenisIdentitas, label: ob.kodeJenisIdentitas + " - " + ob.namaJenisIdentitas }
                            this.importirkodeJenisApi = { code: ob.kodeJenisApi, name: ob.namaKodeJenisApi, label: ob.kodeJenisApi + " - " + ob.namaKodeJenisApi }
                        }
                        if (ob.kodeEntitas == "7") {
                            this.entitasPemilikBarang = ob;
                            this.pemilikBarangTipeIdentitas = { code: ob.kodeJenisIdentitas, name: ob.namaJenisIdentitas, label: ob.kodeJenisIdentitas + " - " + ob.namaJenisIdentitas }
                        }
                        if (ob.kodeEntitas == "11") {
                            this.entitasNpwpPemusatan = ob;
                            this.npwpPemusatanTipeIdentitas = { code: ob.kodeJenisIdentitas, name: ob.namaJenisIdentitas, label: ob.kodeJenisIdentitas + " - " + ob.namaJenisIdentitas }
                        }

                        if (ob.kodeEntitas == "9") {
                            this.entitasPengirim = ob;
                            this.negaraPengirim = { code: ob.kodeNegara, name: ob.namaNegara, label: ob.kodeNegara + " - " + ob.namaNegara }
                        }
                        if (ob.kodeEntitas == "10") {
                            this.entitasPenjual = ob;
                            this.negaraPenjual = { code: ob.kodeNegara, name: ob.namaNegara, label: ob.kodeNegara + " - " + ob.namaNegara }
                        }
                        if (ob.kodeEntitas == "4") {
                            this.entitasPpjk = ob;
                            this.ppjkTipeIdentitas = { code: ob.kodeEntitas, name: ob.namaKodeEntitas, label: ob.kodeEntitas + " - " + ob.namaKodeEntitas }
                        }

                    }

                }



            }).catch(error => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });

        },

        backForm() {
            window.location.href = "/exim/ceisa/dokumen-pabean";
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },

    },
    mounted() {

        this.fetchIt();


    },
};
</script>

<style></style>